export default class Auth {
	static isLoggedIn() {
		return localStorage.getItem('token') ? true : false
	}
}